module.exports = require("./compile/minified/ui-cropper.js");
require("./compile/minified/ui-cropper.css");


//////////////////
// WEBPACK FOOTER
// ui-cropper (bower component)
// module id = 682
// module chunks = 0